
function getFaceValidation(permissions) { 
    return permissions.includes('request_biometrics');
  }


export {
    getFaceValidation,
  };